import { Tracker } from "./types";

export const initTrackerMatomo = (trackers: Array<Tracker>): void => {
  const _paq = window._paq = window._paq || [];
  const trackerPrincipale = trackers.shift();

  _paq.push(['setTrackerUrl', trackerPrincipale.base_url + 'matomo.php']);
  _paq.push(['setSiteId', trackerPrincipale.id_site]);

  trackers.forEach(tracker => {
    _paq.push(['addTracker', tracker.base_url + 'matomo.php', tracker.id_site]);
  })

  const d = document,
  g = d.createElement('script'),
  s = d.getElementsByTagName('script')[0];
  g.type = 'text/javascript';
  g.async = true;
  g.src = trackerPrincipale.base_url + 'matomo.js';
  s.parentNode.insertBefore(g, s);
}

export const trackMatomo = (): void => {
  const _paq = window._paq = window._paq || [];
  _paq.push(['setCustomUrl', '/' + window.location.pathname]);
  _paq.push(['enableLinkTracking']);
  _paq.push(['trackPageView']);
}